/**
 * Base utility for making API requests.
 */

const API_BASE_URL = window.__ENV__?.REACT_APP_API_BASE_URL
  || process.env.REACT_APP_API_BASE_URL
  || 'https://8c4282aa-49a0-437e-93f3-61d0db7f12eb--7011.preview.8080.ai';

export async function request(path, options = {}) {
  const url = `${API_BASE_URL}${path}`;
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.detail || errorData.message || `Error ${response.status}: ${response.statusText}`;

    const error = new Error(errorMessage);

    error.field = errorData.field;
    throw error;
  }

  return response.json();
}
